import { IntegrationSyncSelectOption, SingleSelectInput } from "components";
import { IntegrationEntitySyncStatusEnum } from "enums/integration-entity-sync-status.enum";
import { observer } from "mobx-react";
import { FC, useCallback } from "react";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { TRexSyncLeadSourceExtendedData } from "types/rex.type";
import { TSelectValue } from "types/select-input.type";

interface IProps {
  accountStore: UserAccountStore;
  record: TRexSyncLeadSourceExtendedData;
  onChange: (syncPair: TRexSyncLeadSourceExtendedData) => void;
}

export const RexLeadSourceSyncSelect: FC<IProps> = observer(
  ({ accountStore, record, onChange }) => {
    const options =
      accountStore.accountIntegrationsStore.accountIntegrationRexStore
        .rexLeadSourcesOptions;

    const handleChange = useCallback(
      (rexSource: TSelectValue<string>) => {
        onChange({
          rexId: rexSource || null,
          leadSourceId: record.leadSourceId,
          leadSourceName: record.leadSourceName,
          syncStatus: IntegrationEntitySyncStatusEnum.NOT_SYNCED,
        });
      },
      [onChange, record]
    );

    return (
      <SingleSelectInput
        value={record.rexId}
        clearable={true}
        options={options}
        onChange={handleChange}
        optionComponent={optionProps => (
          <IntegrationSyncSelectOption optionProps={optionProps} />
        )}
      />
    );
  }
);
